import "friendly-challenge/widget";
export default defineNuxtPlugin({
  name: 'friendly-challenge.client',
  enforce: "pre",
  async setup(nuxtApp) {
  }
})
